module.exports = __webpack_public_path__ + "static/favicon-87e4ece40aea5f0aa629a88aabaa7ae5.ico";